import axios from 'axios'

import {
  getApiUrl,
} from '../../../utils/config-utility'

const apiDeleteRequest = apiPath => config => axios.delete(
  getApiUrl() + apiPath,
  config,
)

export default apiDeleteRequest